import React from 'react';

const LedIndicator = () => {
    return (
      <div className="fiveDots">
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </div>
    );
  };

  export default LedIndicator;